import { combineReducers } from "@reduxjs/toolkit";

import { unitNumbersListingReducer } from "./unitNumbersSlice";

export const unitNumbersReducer = combineReducers({
  unitNumbersListing: unitNumbersListingReducer,
});
